var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 228.854,
    height: 79.518,
    viewBox: "0 0 228.854 79.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4544",
    "data-name": "Rectangle 4544",
    width: 228.854,
    height: 79.518,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    d: "M64.6,33.449,58.2,49.293,49.6,28.017H41.15L58.2,63.979,75.321,28.017H72.654A8.686,8.686,0,0,0,64.6,33.449",
    transform: "translate(-7.48 -5.093)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    d: "M145.825,24.249a16.037,16.037,0,0,0-7.952-2.041,13.026,13.026,0,0,0-7.272,2.077,13.266,13.266,0,0,0-3.976,4.075V7.807A7.807,7.807,0,0,0,118.818,0V55.877h7.807V50.422a13.18,13.18,0,0,0,3.976,4.094,13.026,13.026,0,0,0,7.272,2.077,16.037,16.037,0,0,0,7.952-2.041,15.365,15.365,0,0,0,5.873-5.91A18.264,18.264,0,0,0,153.92,39.4a18.217,18.217,0,0,0-2.221-9.277,15.433,15.433,0,0,0-5.873-5.875m-1.29,20.811a9.148,9.148,0,0,1-3.618,3.582,10.306,10.306,0,0,1-4.979,1.218,8.759,8.759,0,0,1-4.369-1.218,9.7,9.7,0,0,1-3.546-3.546,10.875,10.875,0,0,1-1.4-5.695,10.88,10.88,0,0,1,1.4-5.7,9.7,9.7,0,0,1,3.546-3.545,8.761,8.761,0,0,1,4.369-1.218,10.306,10.306,0,0,1,4.979,1.218,9.146,9.146,0,0,1,3.618,3.581A11.175,11.175,0,0,1,145.9,39.4a11.172,11.172,0,0,1-1.362,5.659",
    transform: "translate(-21.598 0)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    d: "M192.325,29.147a18.236,18.236,0,0,0-8.883-2.005,18.712,18.712,0,0,0-9.1,2.113,14.73,14.73,0,0,0-5.981,5.982,18.683,18.683,0,0,0-2.113,9.1,18.777,18.777,0,0,0,2.078,9.027,14.781,14.781,0,0,0,5.909,6.017,17.781,17.781,0,0,0,8.847,2.149,20.272,20.272,0,0,0,9.814-2.221,17.161,17.161,0,0,0,6.663-6.663l-.681-.278a9.954,9.954,0,0,0-9.262,1.1q-.322.212-.659.4a11.343,11.343,0,0,1-5.517,1.29,9.654,9.654,0,0,1-5.122-1.29,8,8,0,0,1-3.188-3.761,13.373,13.373,0,0,1-.961-3.976h25.606a5.743,5.743,0,0,0,.107-.931c.024-.43.036-.835.036-1.218a19.313,19.313,0,0,0-1.97-9.062,13.658,13.658,0,0,0-5.624-5.767m-13.969,5.158a9.317,9.317,0,0,1,5.015-1.29,8.251,8.251,0,0,1,4.262,1.074A7.564,7.564,0,0,1,190.5,37.1a9.129,9.129,0,0,1,.995,3.725H174.37a12.686,12.686,0,0,1,.834-2.794,8.093,8.093,0,0,1,3.153-3.725",
    transform: "translate(-30.22 -4.934)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    "data-name": "Path 7775",
    d: "M26.076,29.147a18.236,18.236,0,0,0-8.883-2.005,18.71,18.71,0,0,0-9.1,2.113,14.731,14.731,0,0,0-5.981,5.982A18.683,18.683,0,0,0,0,44.335a18.777,18.777,0,0,0,2.078,9.027,14.781,14.781,0,0,0,5.909,6.017,17.781,17.781,0,0,0,8.847,2.149,20.272,20.272,0,0,0,9.814-2.221,17.161,17.161,0,0,0,6.663-6.663l-.681-.278a9.954,9.954,0,0,0-9.262,1.1q-.322.212-.659.4a11.343,11.343,0,0,1-5.517,1.29,9.655,9.655,0,0,1-5.122-1.29A8,8,0,0,1,8.883,50.1a13.374,13.374,0,0,1-.961-3.976H33.527a5.743,5.743,0,0,0,.107-.931c.024-.43.036-.835.036-1.218a19.313,19.313,0,0,0-1.97-9.062,13.658,13.658,0,0,0-5.624-5.767M12.107,34.306a9.317,9.317,0,0,1,5.015-1.29,8.246,8.246,0,0,1,4.261,1.074A7.56,7.56,0,0,1,24.249,37.1a9.129,9.129,0,0,1,.995,3.725H8.121a12.687,12.687,0,0,1,.834-2.794,8.093,8.093,0,0,1,3.153-3.725",
    transform: "translate(0 -4.934)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M239.473,7.807V28.435a13.606,13.606,0,0,0-3.976-4.15,12.808,12.808,0,0,0-7.272-2.077,16.089,16.089,0,0,0-7.915,2.041,15.344,15.344,0,0,0-5.91,5.875,18.208,18.208,0,0,0-2.221,9.277,18.256,18.256,0,0,0,2.221,9.241,15.277,15.277,0,0,0,5.91,5.91,16.089,16.089,0,0,0,7.915,2.041,12.808,12.808,0,0,0,7.272-2.077,13.514,13.514,0,0,0,3.976-4.17v5.53h7.808V0a7.808,7.808,0,0,0-7.808,7.807m-1.4,37.288a9.623,9.623,0,0,1-3.582,3.546,8.964,8.964,0,0,1-4.405,1.218,10.164,10.164,0,0,1-4.908-1.218,9.141,9.141,0,0,1-3.617-3.582A11.156,11.156,0,0,1,220.2,39.4a11.159,11.159,0,0,1,1.361-5.66,9.139,9.139,0,0,1,3.617-3.581,10.165,10.165,0,0,1,4.908-1.218,8.965,8.965,0,0,1,4.405,1.218,9.627,9.627,0,0,1,3.582,3.545,10.888,10.888,0,0,1,1.4,5.7,10.883,10.883,0,0,1-1.4,5.695",
    transform: "translate(-38.569 0)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M95.36,33.353V28.017H87.694V60.97H95.36V38.118h6.606a7.665,7.665,0,0,0,7.666-7.665h-8.274a7.646,7.646,0,0,0-6,2.9",
    transform: "translate(-15.941 -5.093)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M260.215,66.588h0a7.666,7.666,0,0,1,7.666-7.666h8.274a7.666,7.666,0,0,1-7.666,7.666Z",
    transform: "translate(-47.301 -10.711)",
    fill: "#b0c933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    d: "M260.215,53.838h0a7.666,7.666,0,0,1,7.666-7.666h8.274a7.666,7.666,0,0,1-7.666,7.666Z",
    transform: "translate(-47.301 -8.393)",
    fill: "#98dbf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M260.215,40.663h0A7.666,7.666,0,0,1,267.881,33h8.274a7.666,7.666,0,0,1-7.666,7.666Z",
    transform: "translate(-47.301 -5.998)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    d: "M2.945,91.287V81.82H4.28l3.033,4.789a26.838,26.838,0,0,1,1.7,3.077l.028-.014c-.113-1.265-.141-2.416-.141-3.891V81.82h1.152v9.467H8.816l-3.005-4.8a29.894,29.894,0,0,1-1.77-3.16L4,83.337c.07,1.194.1,2.332.1,3.9v4.045Z",
    transform: "translate(-0.535 -14.873)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    d: "M14.77,88.671a2.178,2.178,0,0,0,2.332,2.36,4.473,4.473,0,0,0,1.882-.351l.211.884a5.5,5.5,0,0,1-2.262.422,3.157,3.157,0,0,1-3.343-3.428c0-2.05,1.208-3.666,3.189-3.666,2.219,0,2.809,1.952,2.809,3.2a4.686,4.686,0,0,1-.042.575Zm3.624-.884a1.76,1.76,0,0,0-1.713-2.009,2.049,2.049,0,0,0-1.9,2.009Z",
    transform: "translate(-2.47 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    d: "M23.083,85.081l1.335,3.82a17.721,17.721,0,0,1,.547,1.742h.043c.155-.562.351-1.123.576-1.742l1.32-3.82H28.2l-2.669,6.8h-1.18l-2.585-6.8Z",
    transform: "translate(-3.956 -15.466)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    d: "M31.458,88.671a2.178,2.178,0,0,0,2.332,2.36,4.473,4.473,0,0,0,1.882-.351l.211.884a5.5,5.5,0,0,1-2.262.422,3.157,3.157,0,0,1-3.343-3.428c0-2.05,1.208-3.666,3.189-3.666,2.219,0,2.809,1.952,2.809,3.2a4.686,4.686,0,0,1-.042.575Zm3.624-.884a1.76,1.76,0,0,0-1.713-2.009,2.049,2.049,0,0,0-1.9,2.009Z",
    transform: "translate(-5.504 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    d: "M39.469,87.168c0-.8-.014-1.488-.056-2.121h1.081l.043,1.335h.056a2.039,2.039,0,0,1,1.882-1.488,1.316,1.316,0,0,1,.351.042V86.1a1.83,1.83,0,0,0-.421-.042,1.734,1.734,0,0,0-1.658,1.587,3.509,3.509,0,0,0-.056.576v3.624H39.469Z",
    transform: "translate(-7.164 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7786",
    "data-name": "Path 7786",
    d: "M48.667,91.175c.028-.463.056-1.151.056-1.755V81.2h1.222v4.269h.028a2.534,2.534,0,0,1,2.318-1.249c1.686,0,2.879,1.4,2.865,3.469,0,2.43-1.531,3.638-3.048,3.638a2.42,2.42,0,0,1-2.275-1.278H49.79l-.056,1.123Zm1.278-2.725A2.271,2.271,0,0,0,50,88.9a1.905,1.905,0,0,0,1.853,1.447c1.293,0,2.065-1.053,2.065-2.613,0-1.362-.7-2.528-2.023-2.528a1.97,1.97,0,0,0-1.882,1.518,2.4,2.4,0,0,0-.07.506Z",
    transform: "translate(-8.846 -14.761)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7787",
    "data-name": "Path 7787",
    d: "M64.184,90.026c0,.7.014,1.32.056,1.854h-1.1l-.07-1.11h-.029A2.557,2.557,0,0,1,60.8,92.033c-1.068,0-2.346-.59-2.346-2.978V85.081h1.236v3.765c0,1.292.393,2.163,1.517,2.163a1.787,1.787,0,0,0,1.629-1.123,1.807,1.807,0,0,0,.112-.632V85.081h1.236Z",
    transform: "translate(-10.625 -15.466)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7788",
    "data-name": "Path 7788",
    d: "M68.214,85.081,69.7,89.1c.155.449.323.983.435,1.39h.028c.127-.407.267-.926.435-1.419l1.348-3.989h1.307L71.4,89.927c-.885,2.331-1.489,3.525-2.332,4.256a3.363,3.363,0,0,1-1.517.8l-.308-1.04a3.273,3.273,0,0,0,1.082-.6,3.76,3.76,0,0,0,1.039-1.377.875.875,0,0,0,.1-.295,1.07,1.07,0,0,0-.084-.323l-2.514-6.264Z",
    transform: "translate(-12.155 -15.466)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7789",
    "data-name": "Path 7789",
    d: "M83.336,91.844l-.1-.857H83.2A2.532,2.532,0,0,1,81.117,92a1.937,1.937,0,0,1-2.079-1.952c0-1.644,1.461-2.542,4.088-2.528v-.141A1.4,1.4,0,0,0,81.581,85.8a3.383,3.383,0,0,0-1.77.506L79.53,85.5a4.222,4.222,0,0,1,2.234-.6c2.078,0,2.584,1.419,2.584,2.781v2.542a9.562,9.562,0,0,0,.113,1.629Zm-.182-3.469c-1.348-.028-2.879.211-2.879,1.531a1.094,1.094,0,0,0,1.166,1.18,1.691,1.691,0,0,0,1.643-1.137,1.275,1.275,0,0,0,.07-.394Z",
    transform: "translate(-14.367 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7790",
    "data-name": "Path 7790",
    d: "M87.955,86.887c0-.7-.014-1.278-.056-1.84h1.1l.07,1.123h.029a2.5,2.5,0,0,1,2.247-1.278c.942,0,2.4.562,2.4,2.894v4.059H92.506V87.927c0-1.1-.407-2.01-1.573-2.01a1.813,1.813,0,0,0-1.742,1.84v4.088H87.955Z",
    transform: "translate(-15.978 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7791",
    "data-name": "Path 7791",
    d: "M103.539,88.39A3.322,3.322,0,0,1,100.154,92,3.232,3.232,0,0,1,96.9,88.5a3.32,3.32,0,0,1,3.371-3.609,3.219,3.219,0,0,1,3.273,3.5m-5.394.07c0,1.488.857,2.612,2.064,2.612,1.18,0,2.065-1.109,2.065-2.64,0-1.152-.576-2.613-2.037-2.613s-2.093,1.348-2.093,2.641",
    transform: "translate(-17.613 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7792",
    "data-name": "Path 7792",
    d: "M108.239,82.7v1.952h1.77v.941h-1.77v3.666c0,.843.239,1.32.927,1.32a2.759,2.759,0,0,0,.716-.084l.056.927a3.028,3.028,0,0,1-1.1.169,1.711,1.711,0,0,1-1.335-.52,2.516,2.516,0,0,1-.477-1.769V85.588h-1.054v-.941h1.054V83.018Z",
    transform: "translate(-19.264 -15.032)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7793",
    "data-name": "Path 7793",
    d: "M112.6,81.2h1.236v4.242h.028a2.3,2.3,0,0,1,.885-.871,2.551,2.551,0,0,1,1.264-.351c.914,0,2.374.562,2.374,2.907v4.046h-1.236V87.269c0-1.1-.407-2.023-1.573-2.023a1.776,1.776,0,0,0-1.658,1.236,1.494,1.494,0,0,0-.084.59v4.1H112.6Z",
    transform: "translate(-20.469 -14.761)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7794",
    "data-name": "Path 7794",
    d: "M122.712,88.671a2.178,2.178,0,0,0,2.332,2.36,4.473,4.473,0,0,0,1.882-.351l.211.884a5.5,5.5,0,0,1-2.262.422,3.157,3.157,0,0,1-3.343-3.428c0-2.05,1.208-3.666,3.189-3.666,2.219,0,2.809,1.952,2.809,3.2a4.689,4.689,0,0,1-.042.575Zm3.624-.884a1.76,1.76,0,0,0-1.713-2.009,2.049,2.049,0,0,0-1.9,2.009Z",
    transform: "translate(-22.092 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7795",
    "data-name": "Path 7795",
    d: "M130.723,87.168c0-.8-.014-1.488-.056-2.121h1.081l.043,1.335h.056a2.039,2.039,0,0,1,1.882-1.488,1.32,1.32,0,0,1,.351.042V86.1a1.83,1.83,0,0,0-.421-.042A1.733,1.733,0,0,0,132,87.646a3.51,3.51,0,0,0-.056.576v3.624h-1.222Z",
    transform: "translate(-23.752 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7796",
    "data-name": "Path 7796",
    d: "M139.921,91.175c.028-.463.056-1.151.056-1.755V81.2H141.2v4.269h.028a2.534,2.534,0,0,1,2.318-1.249c1.686,0,2.879,1.4,2.865,3.469,0,2.43-1.531,3.638-3.048,3.638a2.42,2.42,0,0,1-2.275-1.278h-.043l-.056,1.123ZM141.2,88.45a2.271,2.271,0,0,0,.056.449,1.905,1.905,0,0,0,1.853,1.447c1.293,0,2.065-1.053,2.065-2.613,0-1.362-.7-2.528-2.023-2.528a1.97,1.97,0,0,0-1.882,1.518,2.4,2.4,0,0,0-.07.506Z",
    transform: "translate(-25.434 -14.761)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7797",
    "data-name": "Path 7797",
    d: "M150.337,88.671a2.178,2.178,0,0,0,2.332,2.36,4.473,4.473,0,0,0,1.882-.351l.211.884a5.5,5.5,0,0,1-2.262.422,3.157,3.157,0,0,1-3.343-3.428c0-2.05,1.208-3.666,3.189-3.666,2.219,0,2.809,1.952,2.809,3.2a4.692,4.692,0,0,1-.042.575Zm3.624-.884a1.76,1.76,0,0,0-1.713-2.009,2.049,2.049,0,0,0-1.9,2.009Z",
    transform: "translate(-27.113 -15.432)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    d: "M164.122,81.2v8.217c0,.6.014,1.292.056,1.756h-1.11l-.056-1.181h-.028a2.512,2.512,0,0,1-2.317,1.335c-1.644,0-2.908-1.39-2.908-3.455-.014-2.262,1.391-3.652,3.048-3.652a2.274,2.274,0,0,1,2.051,1.039h.028V81.2Zm-1.236,5.941a2.165,2.165,0,0,0-.056-.52,1.817,1.817,0,0,0-1.784-1.433c-1.278,0-2.037,1.123-2.037,2.626,0,1.376.674,2.514,2.009,2.514a1.857,1.857,0,0,0,1.812-1.474,2.129,2.129,0,0,0,.056-.534Z",
    transform: "translate(-28.677 -14.761)",
    fill: "#09384c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7799",
    "data-name": "Path 7799",
    d: "M167.512,92.3a.83.83,0,0,1,.843-.885.886.886,0,1,1-.843.885",
    transform: "translate(-30.45 -16.618)",
    fill: "#09384c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2e6dc5b80840c63418a7aea6fe346c01.svg";
export { ForwardRef as ReactComponent };